import React from 'react';
import { RelixMark } from '../../brand/RelixLogo';

/**
 * Lightweight marketing header for the PRERENDERED static twins only
 * (RLX-FEAT-009): gives crawlers and no-JS visitors real outgoing nav links.
 * The SPA keeps the full Layout Navigation — SolutionsPage/HelpPage never
 * render this header, so there is no double header in the app.
 *
 * Plain <a href> only (the prerender mocks react-router-dom). RelixMark is a
 * hook-free <img> — RelixLockup would throw without a ThemeProvider.
 * Pricing is deliberately absent: hidden product-wide until re-opened.
 */
export function MarketingStaticHeader(): React.ReactElement {
  return (
    <header className="marketing-static-header">
      <a className="marketing-static-header__brand" href="/">
        <RelixMark size={28} />
        <span className="marketing-static-header__wordmark">Relix</span>
      </a>
      <nav className="marketing-static-header__nav" aria-label="Main">
        <a href="/solutions">Solutions</a>
        <a href="/help">Help</a>
        <a className="marketing-static-header__cta" href="/auth">
          Sign in
        </a>
      </nav>
    </header>
  );
}
